import { authService } from './../../shared/services/auth.service';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import router from '@/router';
import { i18n, itiMessageService, itiSignalRService } from '@/iti-core-vue';
import itiLayoutMenuModule from '@/store/modules/iti-layout-menu.module';
import { ItiLanguageSelector } from '@/iti-core-vuetify';
import LanguageSelector from '../language-selector/language-selector.component.vue';
import publicLayoutModule from '@/store/modules/public-layout.module';
import NotificationCounterModule from '@/store/modules/contadorNotificaciones.module';
import DxTextBox from 'devextreme-vue/text-box';
import { Notification } from '@/shared/dtos/notificacion';
import listaNotificacionesModule from '@/store/modules/listaNotificaciones.module';

@Component({
    components: {
        DxTextBox,
        LanguageSelector
    },
})
export default class PrivateHeaderComponent extends Vue {
    @Prop() public title!: string;

    public get username() {
        return authService.username;
    }

    public get imgSrcPerson() {
        return process.env.VUE_APP_PUBLIC_PATH + 'assets/person_32x32.png';
    }

    public get items(): string[] {
        return [
            i18n.tc('menuavatar.salir'),
        ];
    }

    public get currentRoute(): string {
        return this.$route.name ? this.$route.name : '';
    }
    public get chatId(): string {
        return this.$route.params.id;
    }
    public get notificaciones() {
        return listaNotificacionesModule.notificaciones;
    }
    public get notificacionesNoLeidas() {
        return listaNotificacionesModule.notificaciones.filter((val, index, array) => {
            return !val.isRead && (val.sourceUser != -2 || this.esUltimaNotificacionSala(val, array))
        });
    }

    private esUltimaNotificacionSala(notificacion: Notification, array: Notification[]): boolean {
        if (!array.find(x => !x.isRead && x.idEventSource == notificacion.idEventSource && x.creationDate > notificacion.creationDate))
            return true;
        else
            return false;
    }

    public get notificationCounter(): string {
        return this.notificacionesNoLeidas.length + '';
    }

    public receiveNotificationHandler(notificacion: Notification) {
        listaNotificacionesModule.addNotificacion(notificacion);
    }

    public async created() {
        itiSignalRService.setWebChannelHubBase(process.env.VUE_APP_ROOT_CHATHUB as string);
        //get the current number of pending notifications to show it on the toolbar
        if (listaNotificacionesModule.notificaciones.length == 0) {
            await listaNotificacionesModule.cargarNotificaciones();
        }
        setTimeout(() => itiSignalRService.listenFor('receiveNotification', this.receiveNotificationHandler), 5000);
    }

    public notifications() {
        router.push({ name: 'Notificaciones' });
    }

    public settings() {
        router.push({ name: 'Cuenta' });
    }

    public logout() {
        itiMessageService.confirm(this.$tc('menuavatar.salir-confirmacion'), this.$tc('mensajes.confirmar'), (result) => {
            if(result) {
                authService.logout();
            }
          });
    }

}